module.exports = __webpack_public_path__ + "static/media/sample_home_wireframe_2.0062931b.png";